
import React, { useEffect, ReactNode } from 'react';
import posthog from 'posthog-js';
import { supabase } from '@/integrations/supabase/client';

interface PostHogProviderProps {
  children: ReactNode;
}

export const PostHogProvider = ({ children }: PostHogProviderProps) => {
  useEffect(() => {
    const initializePostHog = async () => {
      try {
        // Fetch PostHog configuration from edge function
        const { data, error } = await supabase.functions.invoke('get-posthog-config');
        
        if (error) {
          console.error('Error fetching PostHog config:', error);
          return;
        }

        if (data?.apiKey) {
          // Initialize PostHog with the API key from Supabase
          posthog.init(data.apiKey, {
            api_host: data.apiHost || 'https://app.posthog.com',
            // Enable session recordings (enabled by default when this object is present)
            session_recording: {},
            // Capture pageviews automatically
            capture_pageview: true,
            // Capture performance metrics
            capture_performance: true,
          });
        }
      } catch (error) {
        console.error('Failed to initialize PostHog:', error);
      }
    };

    initializePostHog();

    // Clean up on unmount
    return () => {
      if (posthog.__loaded) {
        posthog.reset();
      }
    };
  }, []);

  return <>{children}</>;
};
